module.exports = __webpack_public_path__ + "static/media/area_marketing.0e965162.webp";